export enum PaymentMethodType {
  Cash,
  CreditCard,
  BankTransfer,
  Oxxo,
  MercadoPago
}